import React, { useEffect, useState } from 'react';
import { animateScroll as scroll } from 'react-scroll';

import FloatingMenu from '../FloatingMenu';

import NCSLogoIcon from '../../assets/ncs-logo-icon.svg';
import ChildhoodLogo from '../../assets/childhood-logo.svg';
import MenuIcon from '../../assets/menu-icon.svg';
import './styles.css';

const NavBar = ({ data, currentPage, changePage }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showSection, setShowSection] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const headers = [
                ...document.getElementsByClassName('ncs-content-header'),
            ].map((header) => header.getBoundingClientRect());

            let headerOnScreen = 0;
            headers.forEach((header) => (headerOnScreen += header.bottom));
            setShowSection(headerOnScreen < 0);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [data, currentPage]);

    const scrollToTop = () => {
        scroll.scrollToTop({
            duration: 300,
            smooth: 'easeInOutQuart',
        });
    };

    const closeMenu = () => {
        setShowMenu(false);
    };

    const choosePage = (index) => {
        changePage(index);
        closeMenu();
    };

    return (
        <>
            <nav id='ncs-navbar' className={data ? 'show-menu-button' : ''}>
                {showSection && data && currentPage !== 0 && (
                    <button id='ncs-navbar-section' onClick={() => scrollToTop()}>
                        <div
                            id='ncs-navbar-section-icon'
                            style={{
                                maskImage: `url(${data[currentPage].icon + '?not-from-cache'})`,
                                WebkitMaskImage: `url(${
                                    data[currentPage].icon + '?not-from-cache'
                                })`,
                            }}
                        />
                        <span id='ncs-navbar-section-name'>{data[currentPage].island}</span>
                    </button>
                )}
                {(!showSection || currentPage === 0) && (
                    <>
                        <button id='ncs-navbar-logo' onClick={() => choosePage(0)}>
                            <div
                                style={{
                                    maskImage: `url(${NCSLogoIcon})`,
                                    WebkitMaskImage: `url(${NCSLogoIcon})`,
                                }}
                            />
                            <span>Navegar com Segurança</span>
                        </button>
                        <div>
                            <a
                                id='ncs-navbar-childhood-logo'
                                href='https://www.childhood.org.br/'
                                target='__blank'
                                rel='noreferrer'
                            >
                                <img src={ChildhoodLogo} alt='Childhood Brasil' />
                            </a>
                            {data && (
                                <button
                                    id='ncs-navbar-menu-button'
                                    className={showMenu ? 'menu-enabled' : 'menu-disabled'}
                                    onClick={() => {
                                        setShowMenu(!showMenu);
                                    }}
                                >
                                    <img src={MenuIcon} alt='Menu' />
                                </button>
                            )}
                        </div>
                    </>
                )}
            </nav>
            {data && showMenu && (
                <FloatingMenu
                    data={data}
                    choosePage={choosePage}
                    closeMenu={closeMenu}
                />
            )}
        </>
    );
};

export default NavBar;
